import { makeStyles } from '@material-ui/styles'
import UsersPicklist from 'account/components/userManagement/users/UsersPicklist'
import TenantPicklist from 'account/components/userManagement/tenants/TenantPicklist'
import React from 'react'
import FlavorPicklist from '../flavors/FlavorPickList'
import ImagePicklist from '../images/ImagePicklist'
import SimpleClusterPicklist from '../infrastructure/clusters/SimpleClusterPicklist'
import VMStatePicklist from './VMStatePicklist'
import HostPicklist from '../infrastructure/hosts/HostPicklist'
import { isAdmin } from 'app/plugins/infrastructure/components/common/helpers'
import { VMFilterParams } from './VMServerSideSearch'

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: 'auto',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
  },
  title: {
    alignSelf: 'flex-end',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1.5),
  },
  filterDropdown: {
    width: 150,
    minWidth: 100,
    maxWidth: 200,
  },
  iconButton: {
    width: 38,
    height: 38,
  },
  clearFilters: {
    alignSelf: 'flex-end',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1.5),
  },
}))

export interface VMServerSideFiltersProps {
  params: VMFilterParams
  updateParams: (newParams: Partial<VMFilterParams>) => void
  disabled?: boolean
  allTenants?: boolean
  excludeFilters?: string[]
}

export const VMServerSideFilters: React.FC<VMServerSideFiltersProps> = ({
  params,
  updateParams,
  disabled = false,
  allTenants = false,
  excludeFilters = [],
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {/* <Text variant="body2" className={classes.title}>
        Filter By
      </Text> */}
      {allTenants && !excludeFilters.includes('tenant_id') && (
        <TenantPicklist
          id="tenant_id"
          name="tenant_id"
          value={params.tenant_id || ''}
          onChange={(value) => updateParams({ tenant_id: value })}
          label="Tenant"
          includeAllOption
          className={classes.filterDropdown}
          disabled={disabled}
          compact={false}
        />
      )}
      {!excludeFilters.includes('cluster') && (
        <SimpleClusterPicklist
          id="cluster"
          name="cluster"
          value={params.cluster}
          onChange={(value) => updateParams({ cluster: value })}
          label="Cluster"
          includeAllOption
          className={classes.filterDropdown}
          disabled={disabled}
          compact={false}
        />
      )}
      {!excludeFilters.includes('vm_state') && (
        <VMStatePicklist
          id="vm_state"
          name="vm_state"
          value={params.vm_state}
          onChange={(value) => updateParams({ vm_state: value })}
          label="VM State"
          includeAllOption
          className={classes.filterDropdown}
          disabled={disabled}
          compact={false}
        />
      )}
      {isAdmin() && !excludeFilters.includes('owner') && (
        <UsersPicklist
          id="owner"
          name="owner"
          value={params.owner}
          onChange={(value) => updateParams({ owner: value })}
          label="Owner"
          includeAllOption
          className={classes.filterDropdown}
          disabled={disabled}
          compact={false}
        />
      )}
      {!excludeFilters.includes('flavor') && (
        <FlavorPicklist
          id="flavor"
          name="flavor"
          value={params.flavor}
          onChange={(value) => updateParams({ flavor: value })}
          label="Flavor"
          includeAllOption
          className={classes.filterDropdown}
          disabled={disabled}
          compact={false}
        />
      )}
      {!excludeFilters.includes('image') && (
        <ImagePicklist
          id="image"
          name="image"
          value={params.image}
          onChange={(value) => updateParams({ image: value })}
          label="Image"
          includeAllOption
          className={classes.filterDropdown}
          disabled={disabled}
          compact={false}
        />
      )}
      {isAdmin() && !excludeFilters.includes('host') && (
        <HostPicklist
          id="host"
          name="host"
          value={params.host}
          onChange={(value) => updateParams({ host: value })}
          label="Host"
          includeAllOption
          className={classes.filterDropdown}
          disabled={disabled}
          compact={false}
        />
      )}
    </div>
  )
}
export default VMServerSideFilters
